import React, { Component } from 'react'
import { Input } from 'components/Utils/Form'
import * as Icons from 'components/Utils/Icons'

class SearchBox extends Component {
  onInputChange = event => {
    const value = event.target.value
    this.props.onChange(value)
  }

  render() {
    const { query } = this.props
    return (
      <div className="flexbox flexbox-align-center border-bottom-small border-shade-30">
        <Icons.SearchIcon
          size={12}
          className="flexbox-no-grow shade-30 margin-left-medium"
        />
        <Input
          className="width-full border-none flexbox-grow"
          style={{ padding: '0 8px' }}
          autoFocus
          tabIndex="-1"
          ref={ref => (this.input = ref)}
          placeholder={'Search user or channel'}
          onChange={this.onInputChange}
          value={query}
        />
      </div>
    )
  }
}

export default SearchBox
